export default __webpack_public_path__ + "static/media/d10.5c7b4077.svg";